// API Configuration
import { API_BASE_URL } from './api.config';

// Asset Transfer Constants
export const TRANSFER_STATUS = {
  DRAFT: 'draft',
  PENDING: 'pending',
  APPROVED: 'approved',
  CHECKED_OUT: 'checked_out',
  CHECKED_IN: 'checked_in',
  REJECTED: 'rejected',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  // RFID-enabled transfer status values
  IN_TRANSIT: 'in_transit',
  ARRIVED: 'arrived',
  RECEIVED: 'received'
};

// Asset Disposal Constants
export const DISPOSAL_STATUS = {
  DRAFT: 'draft',
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

export const TRANSFER_REASONS = [
  { value: 'relocation', label: 'Relocation' },
  { value: 'reassignment', label: 'Reassignment' },
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'disposal', label: 'Disposal' },
  { value: 'other', label: 'Other' }
];

// Pagination Constants
export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50,100];
